export default __webpack_public_path__ + "static/NotoSans-Bold.subset-d24638c16e93374d858f20f6cff68c84.otf";